import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import "../styles/NewsPage.css";
import { getUserLanguage } from "../utils";

import { collection, query, where, getDocs } from "firebase/firestore";
import { db } from "../firebase"; // Ensure this path is correct in your project

const NewsPage = () => {
  const { t } = useTranslation();
  const [news, setNews] = useState([]);
  const [filteredNews, setFilteredNews] = useState([]);
  const [categories, setCategories] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState(t("newsBanner.all"));

  useEffect(() => {
    const fetchNews = async () => {
      const userLanguage = getUserLanguage();
      try {
        const newsQuery = query(
          collection(db, "news"),
          where("language", "==", userLanguage)
        );
        const querySnapshot = await getDocs(newsQuery);
        const newsData = [];
        const categoriesSet = new Set();
        querySnapshot.forEach((doc) => {
          const newsItem = { id: doc.id, ...doc.data() };
          newsData.push(newsItem);
          if (newsItem.category) {
            categoriesSet.add(newsItem.category);
          }
        });
        setNews(newsData);
        setFilteredNews(newsData);
        setCategories([t("newsBanner.all"), ...Array.from(categoriesSet)]);
      } catch (error) {
        console.error("Error fetching news:", error);
      }
    };

    fetchNews();
  }, []);

  const handleCategoryChange = (category) => {
    setSelectedCategory(category);
    if (category === t("newsBanner.all")) {
      setFilteredNews(news);
    } else {
      setFilteredNews(news.filter((item) => item.category === category));
    }
  };

  return (
    <section className="news-page">
      <h2>{t("newsBanner.header")}</h2>

      <div className="news-categories">
        {categories.map((category) => (
          <button
            key={category}
            className={`category-button ${
              selectedCategory === category ? "active" : ""
            }`}
            onClick={() => handleCategoryChange(category)}
          >
            {category}
          </button>
        ))}
      </div>

      <div className="news-list">
        {filteredNews.map((item) => (
          <div className="news-item" key={item.id}>
            <img
              src={item.image}
              alt={item.title}
              className="news-item-image"
            />
            <div className="news-item-content">
              <h3>{item.title}</h3>
              <p className="news-item-date">
                {new Date(item.date).toLocaleDateString()}
              </p>

              <a
                rel="canonical"
                href={`/news/${item.id}`}
                className="read-more"
              >
                {t("newsBanner.readMore")}
              </a>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default NewsPage;
